var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"comment-box"},[_c('v-container',[(_vm.metadata)?_c('Disqus',{attrs:{"shortname":"happyly-1","identifier":_vm.metadata.identifier,"url":_vm.metadata.url}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }